/* Almla redesign: email signups also subscribe the shopper to a Klaviyo list
   (the list that starts the client's Welcome Series), through Klaviyo's public
   client API. Forms opt in with data-klaviyo-list and data-klaviyo-company.
   The Shopify customer form still submits afterwards, so the newsletter tags
   and Shopify marketing consent stay as they were. */
(function () {
  [].forEach.call(document.querySelectorAll("form[data-klaviyo-list]"), function (form) {
    form.addEventListener("submit", function (e) {
      if (form.__klaviyoSent) return;
      var email = form.querySelector('input[type="email"]');
      var list = form.getAttribute("data-klaviyo-list");
      var company = form.getAttribute("data-klaviyo-company");
      if (!email || !email.value || !list || !company) return;
      e.preventDefault();
      form.__klaviyoSent = true;
      var body = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: form.getAttribute("data-klaviyo-source") || "Website signup",
            profile: { data: { type: "profile", attributes: { email: email.value.trim() } } }
          },
          relationships: { list: { data: { type: "list", id: list } } }
        }
      };
      var done = function () { HTMLFormElement.prototype.submit.call(form); };
      var timer = setTimeout(done, 3000);
      fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(company), {
        method: "POST",
        keepalive: true,
        headers: { "Content-Type": "application/vnd.api+json", revision: "2024-10-15" },
        body: JSON.stringify(body)
      }).catch(function () {}).then(function () { clearTimeout(timer); done(); });
    });
  });
})();
